import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@buildpy/ui/select";

const ThemeSelect = () => {
  const { setTheme, theme } = useTheme();

  return (
    <Select defaultValue={theme || "system"} onValueChange={setTheme}>
      <SelectTrigger
        className="w-fit"
        isArrowIcon={false}
        size="sm"
        variant="ghost">
        <SelectValue asChild>
          {/* 해·달 전환은 CSS(dark:)로만 처리한다 — resolvedTheme 으로 분기하면
              서버(light)와 클라이언트(저장된 테마) 렌더가 어긋나 하이드레이션이
              깨진다. */}
          <span className="relative flex size-4 items-center justify-center">
            <Sun className="absolute size-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
            <Moon className="absolute size-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          </span>
        </SelectValue>
        <span className="sr-only">테마 변경</span>
      </SelectTrigger>
      <SelectContent align="end">
        <SelectItem value="light">라이트 모드</SelectItem>
        <SelectItem value="dark">다크 모드</SelectItem>
        <SelectItem value="system">시스템 설정</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default ThemeSelect;
